export default __webpack_public_path__ + "static/media/IconDesc_SteelIngot.256.6a930972.png";